import React, { Component } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './ZoomCarousel.css';

import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import irrigationImage from "../images/imagesHome/HomePage/ProductImages/Irrigation_Management.webp";
import etImage from "../images/imagesHome/HomePage/ProductImages/Evapotranspiration.webp";
import vicImage from "../images/imagesHome/HomePage/ProductImages/Hydrological_Modeling.webp";
import hdImage from "../images/imagesHome/HomePage/ProductImages/Hydrological_Drought.webp";
import snowImage from "../images/imagesHome/HomePage/ProductImages/Snowmelt_Runoff.webp";
import glofImage from "../images/imagesHome/HomePage/ProductImages/Glacial_Lakes.webp";
import floodImage from "../images/imagesHome/HomePage/ProductImages/Flood_Early_Warning.webp";
import humid from "../images/imagesHome/HomePage/ProductImages/HUMID.webp";
import drought from "../images/imagesHome/HomePage/ProductBackgroundImages/Hydrological_Drought.webp";
import flood from "../images/imagesHome/HomePage/ProductBackgroundImages/Flood_Early_Warning.webp"
import et from "../images/imagesHome/HomePage/ProductBackgroundImages/Evapotranspiration.webp";
import glacial from "../images/imagesHome/HomePage/ProductBackgroundImages/Glacial_Lakes.webp";
import snow from "../images/imagesHome/HomePage/ProductBackgroundImages/Snowmelt.webp";
import vic from '../images/imagesHome/HomePage/ProductBackgroundImages/Hydrological_Modeling.webp';
import irr from '../images/imagesHome/HomePage/ProductBackgroundImages/Irrigation.webp';
import hum from '../images/imagesHome/HomePage/ProductBackgroundImages/HUMID.webp';

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from "react-router-dom";
import { Grid, Image } from "semantic-ui-react";
import { borderLeft } from '@mui/system';
class SliderProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
        currentSlide: 0,
        middleCard: this.cards[0], // Set the initial middle card
      };
    }
    
      cards = [
    { id: 1, title:"Hydrological Modelling",backgroundImage: vic, image: vicImage, text: 'Daily estimation of water balance components.	Value added products: Inflow into major reservoirs, Soil Moisture Availability Index, forecast surface runoff, forecast of river discharge.	Long term water balance components database', link: '/webgis-vic/map' },
    { id: 2,title:"Flood Early Warning System ", backgroundImage: flood,image: floodImage, text: "Spatial flood early warning model for Godavari and Tapi river basins. Spatial flood alerts (hydrograph, flood inundation extent and depth) with two-days lead time", link: '/webgis-flood/map' },
    { id: 3,title:"Glacial Lake", backgroundImage: glacial,image: glofImage, text:'Comprehensive database of glacial lakes of size > 0.25ha in the Indian Himalayan River Basins. Glacial Lake Outburst Flood (GLOF) modeling simulations for selected glacial lakes. GLOF risk zone maps for downstream areas of selected glacial lakes' , link: '/webgis-glacials/map' },
    { id: 4, title:"Evapotranspiration",backgroundImage:et ,image:etImage , text: 'Daily evapotranspiration over India at 5.5km and 750m spatial resolution using space-based inputs. Data duration: 2015 - Present', link: '/webgis-et/map' },
    { id: 5, title:"Snowmelt Runoff",backgroundImage: snow,image: snowImage, text: 'Daily snow cover map for entire Indian Himalayan basins. Daily snowmelt gridded/ 3-day snowmelt gridded forecast products during snowmelt season. Short term snowmelt runoff forecast at selected basin outlets during snowmelt season', link: '/webgis-snow/map' },
    { id: 6,title:"Hydrological Drought", backgroundImage: drought,image: hdImage, text: "Monthly Composite Hydrological Drought Index using surface runoff, groundwater & reservoir storages datasets.	Pan-India Standardized Runoff Index (SRI) and Standardized Water Spread Index (SWSI) at 3'X3' resolution.", link: '/webgis-drought/map' },
    { id: 7,title:"Irrigation",  backgroundImage: irr, image: irrigationImage, text: "Develop an efficient DSS for irrigation using real-time satellite data. Portal showcases Narayanpur irrigation system's geospatial database. Updates in-season crop maps and canal-wise irrigation deliveries", link: '/webgis-irrigation/map' },
    { id: 8, title:"HUMID", backgroundImage: hum ,image: humid, text: "Web-based interactive hydrological modelling system with SWAT as core modelling engine. Online development, execution, and storage of a user's modelling projects along with output visualisation", link: 'https://bhuvan.nrsc.gov.in/humid/' },
    { id: 9, title:"Hydrological Modelling",backgroundImage: vic, image: vicImage, text: 'Daily estimation of water balance components.	Value added products: Inflow into major reservoirs, Soil Moisture Availability Index, forecast surface runoff, forecast of river discharge.	Long term water balance components database', link: '/webgis-vic/map' },
    { id: 10,title:"Flood Early Warning System ", backgroundImage: flood,image: floodImage, text: "Spatial flood early warning model for Godavari and Tapi river basins. Spatial flood alerts (hydrograph, flood inundation extent and depth) with two-days lead time", link: '/webgis-flood/map' },
    { id: 11,title:"Glacial Lake", backgroundImage: glacial,image: glofImage, text:'Comprehensive database of glacial lakes of size > 0.25ha in the Indian Himalayan River Basins. Glacial Lake Outburst Flood (GLOF) modeling simulations for selected glacial lakes. GLOF risk zone maps for downstream areas of selected glacial lakes' , link: '/webgis-glacials/map' },
    { id: 12, title:"Evapotranspiration",backgroundImage:et ,image:etImage , text: 'Daily evapotranspiration over India at 5.5km and 750m spatial resolution using space-based inputs. Data duration: 2015 - Present', link: '/webgis-et/map' },
    { id: 13, title:"Snowmelt Runoff",backgroundImage: snow,image: snowImage, text: 'Daily snow cover map for entire Indian Himalayan basins. Daily snowmelt gridded/ 3-day snowmelt gridded forecast products during snowmelt season. Short term snowmelt runoff forecast at selected basin outlets during snowmelt season', link: '/webgis-snow/map' },
    { id: 14,title:"Hydrological Drought", backgroundImage: drought,image: hdImage, text: "Monthly Composite Hydrological Drought Index using surface runoff, groundwater & reservoir storages datasets.	Pan-India Standardized Runoff Index (SRI) and Standardized Water Spread Index (SWSI) at 3'X3' resolution.", link: '/webgis-drought/map' },
    { id: 15,title:"Irrigation",  backgroundImage: irr, image: irrigationImage, text: "Develop an efficient DSS for irrigation using real-time satellite data. Portal showcases Narayanpur irrigation system's geospatial database. Updates in-season crop maps and canal-wise irrigation deliveries", link: '/webgis-irrigation/map' },
    { id: 16, title:"HUMID", backgroundImage: hum ,image: humid, text: "Web-based interactive hydrological modelling system with SWAT as core modelling engine. Online development, execution, and storage of a user's modelling projects along with output visualisation", link: 'https://bhuvan.nrsc.gov.in/humid/' },
    { id: 17, title:"Hydrological Modelling",backgroundImage: vic, image: vicImage, text: 'Daily estimation of water balance components.	Value added products: Inflow into major reservoirs, Soil Moisture Availability Index, forecast surface runoff, forecast of river discharge.	Long term water balance components database', link: '/webgis-vic/map' },
    { id: 18,title:"Flood Early Warning System ", backgroundImage: flood,image: floodImage, text: "Spatial flood early warning model for Godavari and Tapi river basins. Spatial flood alerts (hydrograph, flood inundation extent and depth) with two-days lead time", link: '/webgis-flood/map' },
    { id: 19,title:"Glacial Lake", backgroundImage: glacial,image: glofImage, text:'Comprehensive database of glacial lakes of size > 0.25ha in the Indian Himalayan River Basins. Glacial Lake Outburst Flood (GLOF) modeling simulations for selected glacial lakes. GLOF risk zone maps for downstream areas of selected glacial lakes' , link: '/webgis-glacials/map' },
    { id: 20, title:"Evapotranspiration",backgroundImage:et ,image:etImage , text: 'Daily evapotranspiration over India at 5.5km and 750m spatial resolution using space-based inputs. Data duration: 2015 - Present', link: '/webgis-et/map' },
    { id: 21, title:"Snowmelt Runoff",backgroundImage: snow,image: snowImage, text: 'Daily snow cover map for entire Indian Himalayan basins. Daily snowmelt gridded/ 3-day snowmelt gridded forecast products during snowmelt season. Short term snowmelt runoff forecast at selected basin outlets during snowmelt season', link: '/webgis-snow/map' },
    { id: 22,title:"Hydrological Drought", backgroundImage: drought,image: hdImage, text: "Monthly Composite Hydrological Drought Index using surface runoff, groundwater & reservoir storages datasets.	Pan-India Standardized Runoff Index (SRI) and Standardized Water Spread Index (SWSI) at 3'X3' resolution.", link: '/webgis-drought/map' },
    { id: 23,title:"Irrigation",  backgroundImage: irr, image: irrigationImage, text: "Develop an efficient DSS for irrigation using real-time satellite data. Portal showcases Narayanpur irrigation system's geospatial database. Updates in-season crop maps and canal-wise irrigation deliveries", link: '/webgis-irrigation/map' },
    { id: 24, title:"HUMID", backgroundImage: hum ,image: humid, text: "Web-based interactive hydrological modelling system with SWAT as core modelling engine. Online development, execution, and storage of a user's modelling projects along with output visualisation", link: 'https://bhuvan.nrsc.gov.in/humid/' },
  
  ];

  settings = {
    arrows:false ,

    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: '8px',
    autoplay: true,
    autoplaySpeed: 1000,
    beforeChange: (oldIndex, newIndex) => this.handleBeforeChange(oldIndex, newIndex),

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
        },
      },
    ],
    prevArrow: (
      <Button>
        <FontAwesomeIcon icon={faArrowLeft} />
      </Button>
    ),
    nextArrow: (
      <Button style={{color:"#f55449"}}>
        <FontAwesomeIcon icon={faArrowRight} />
      </Button>
    ),
  };

  setCurrentSlide = (newIndex) => {
    this.setState({ currentSlide: newIndex });
  };

  handleButtonClick = (link) => {
    window.open(link, '_self')
  };

  handleMiddleCardClick = (backgroundImage) => {
    // Pass the background image to the parent component
    this.setState({ middleCardBackground: backgroundImage });
  };
  handleBeforeChange = (oldIndex, newIndex) => {
    // Set the current slide index
    this.setState({ middleCard: this.cards[newIndex] });
  };

  render() {

    const { middleCard } = this.state;
    const isExternalLink = this.cards && this.cards.link &&this.cards.link.startsWith('https');

  return (

    <Container fluid>
      <Row>
    <Col> <Container fluid className="big-title"> 
    <h2 className="blue-text1">Geospatial<span className="red-text1">Products</span>& Services</h2>
         
</Container></Col>
</Row>
    <Row><Col>
    <Container fluid className='SliderProduct-container'
    style={{

      backgroundImage: `url(${middleCard.backgroundImage || ''})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition:"center",
       height:"86vh"
      
    }}> 
      <Row>
        <Col >
  
        <Slider {...this.settings}>
            {this.cards.map((card, index) => (
                 <div
                 key={card.id}
                 className={`zoom-card ${
                   index === this.state.currentSlide
                   ? 'middle-card'
                   : index === this.state.currentSlide - 1 || index === this.state.currentSlide + 1
                   ? 'left-right-card'
                   : ''
               }`}>
              <Card className='Slidercarousel'>
              <Card.Title style={{color:"#ffffff",backgroundColor:"#217ca3",textAlign:"center",height:"30px"}}>{card.title}</Card.Title>

        <Card.Img variant="middle" src={card.image} alt={card.title} style={{marginTop:"-12px"}} />
        {middleCard.id === card.id && (
          <>         

                  <Card.Body  >

                    
          <Card.Text class="textleft" style={{color:"#ffffff" ,  textAlign: "justify",
 marginLeft:"-30px",height:"150px",marginTop:"20px",textAlign:"justify"}}>
        <ul className="tick-list">
  {card.text.split(/(?<!\d)\.(?!\d)/).map((line, index) => (
    line.trim() && (
      <li key={index} style={{ marginBottom: '15px' }}>
        {line.trim()}
      </li>
    )
  ))}
</ul>
          
          </Card.Text>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>

          {card.title==="HUMID" ? (
        <Button
          className='productbtn'
          size="sm"
          style={{ marginTop: "2px" }}
          as="a"
          href={card.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          Explore  <FontAwesomeIcon icon={faChevronRight} />
        </Button>
      ) : (
        <Button
          className='productbtn'
          size="sm"
          style={{ marginTop: "2px" }}
          as={Link}
          to={card.link}
        >
          Explore  <FontAwesomeIcon icon={faChevronRight} />
        </Button>
      )}
       
</div>
          </Card.Body>

        </>
         )}
      </Card>
              </div>
            ))}
          </Slider>
          </Col>
          </Row>
          </Container>
        
          </Col>
          </Row>
          </Container>
        
    
   
    );
  }
}

export default SliderProducts;